import { render } from "./NavBarTop.vue?vue&type=template&id=05539f2a&scoped=true"
import script from "./NavBarTop.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarTop.vue?vue&type=script&setup=true&lang=js"

import "./NavBarTop.vue?vue&type=style&index=0&id=05539f2a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05539f2a"],['__file',"src/components/app/nav/NavBarTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05539f2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05539f2a', __exports__)) {
    api.reload('05539f2a', __exports__)
  }
  
  module.hot.accept("./NavBarTop.vue?vue&type=template&id=05539f2a&scoped=true", () => {
    api.rerender('05539f2a', render)
  })

}


export default __exports__